import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { TooltipText } from 'components';
import { Trans } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  content: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.marginBase / 2,
  },
  text: {
    ...theme.fonts.caption,
    color: theme.colors.blueAccessible,
    textAlign: 'right',
    flex: 1,
  },
  icon: {
    fontSize: theme.iconSize.regular,
    color: theme.colors.blueAccessible,
    marginLeft: theme.marginBase / 2,
    display: 'block',
  },
}));

interface Props {
  text?: string;
}

export const DataFormatGuide = ({ text }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  if (!text) {
    return null;
  }

  return (
    <TooltipText title={text} placement="left">
      <div className={classes.content}>
        <div className={classes.text}>
          <Trans i18nKey="participants.list.importCsv.mapping.guide" />
        </div>
        <i className={classnames('ri-question-line', classes.icon)} />
      </div>
    </TooltipText>
  );
};
